import React, { useRef } from "react";
import { Button, ButtonGroup, Flex, Text, Image, Box, Divider, Card, CardBody } from "@chakra-ui/react";
import { Link } from "react-router-dom";
import Slideshow from "./Slideshow";
import { kiwiCritiques } from "../../info/kiwi_critiques";

const wireframes = [
  "/images/uiux_images/riki wireframe.png",
  "/images/uiux_images/michelle wireframe.jpg",
  "/images/uiux_images/kiera wireframe.jpg",
  "/images/uiux_images/jess wireframe.jpg"
];

const hifis = [
  "/images/uiux_images/oldfig1.png",
  "/images/uiux_images/old fig2.png",
  "/images/uiux_images/old fig3.png",
  "/images/uiux_images/old fig4.png",
  "/images/uiux_images/old fig5.png",
  "/images/uiux_images/old fig76.png",
  "/images/uiux_images/old fig7.png",
  "/images/uiux_images/old fig8.png",
  "/images/uiux_images/old fig9.png",
  "/images/uiux_images/old fig10.png",
];

export default function Kiwi() {
  return (
    <Flex pt="10vh" justifyContent={"center"} flexDir={"column"}>
      <Flex
        mt="2%"
        py="1rem"
        alignItems={"center"}
        justifyContent={"center"}
        flexDir={"column"}
        px={{ base: 10, md: 20 }}
      >
        <Text variant={"tinyHeader"} textAlign={"center"}>
          Kiwi Iterative Protoyping
        </Text>
        <Image
          objectFit="contain"
          maxWidth={{ base: "100%", md: "50%" }}
          src={"/images/uiux_images/iterative mockup2.png"}
          borderRadius={"1rem"}
          my="2rem"
        />
        <Text variant={"subtitle"} w="50%" textAlign={"center"}>
          Designing intuitive and effective UIs requires a thorough process that
          includes research, user testing, receiving feedback, and revising
          designs. In this project, our group of four explored how we could
          create an interface for KIWI, a Y Combinator-accelerated startup that
          allows mobile users to send and receive music to each other’s home
          screens.
        </Text>
        <Image
          objectFit="contain"
          maxWidth={{ base: "100%", md: "40%" }}
          src={"/images/uiux_images/steps.png"}
          borderRadius={"1rem"}
          my="2rem"
        />
      </Flex>
      <Flex
        py="1rem"
        alignItems={"center"}
        justifyContent={"center"}
        flexDir={"column"}
        px={{ base: 10, md: 20 }}
        bg="#557159"
      >
        <Text
          variant={"subUIHeader"}
          textAlign={"center"}
          color="white"
          py="1rem"
        >
          1. Sketching
        </Text>
        <Box
          borderRadius={".5rem"}
          bg="white"
          p="1rem"
          w="50%"
          display={"flex"}
        >
          <Divider
            variant="thick"
            orientation="vertical"
            borderColor="#557159"
            mr="1rem"
          />
          <Text variant={"subtitle"}>
            To get ideas flowing, we created four total initial designs, each
            consisting of three screens of our choice. This gave us twelve total
            initial sketches for us to work with:
          </Text>
        </Box>
        <Slideshow pics={wireframes} />
      </Flex>
      <Flex
        py="1rem"
        alignItems={"center"}
        justifyContent={"center"}
        flexDir={"column"}
        px={{ base: 10, md: 20 }}
        bg="#1F3522"
      >
        <Text
          variant={"subUIHeader"}
          textAlign={"center"}
          color="white"
          py="1rem"
        >
          2. Wireframe & Prototyping
        </Text>
        <Box
          borderRadius={".5rem"}
          bg="white"
          p="1rem"
          w="50%"
          display={"flex"}
        >
          <Divider
            variant="thick"
            orientation="vertical"
            borderColor="#557159"
            mr="1rem"
          />
          <Text variant={"subtitle"}>
            The functionality of all of the sketches were included in the
            wireframes, as there were 2 home frames, 3 send frames, a discover
            frame, and 2 profile frames. Moreover, in terms of layout and style,
            we combined different elements from each of the designs.
          </Text>
        </Box>
        <Slideshow pics={hifis} />
      </Flex>
      <Flex
        py="2rem"
        alignItems={"center"}
        justifyContent={"space-evenly"}
        flexDir={{base: "column", lg: "row"}}
        px={{ base: 10, md: 20 }}
        bg="#557159"
      >
        <Flex
          alignItems={"flex-start"}
          justifyContent={"center"}
          flexDir={"column"}
          w="30%"
        >
          <Text variant={"subUIHeader"} color="white" py="1rem">
            3. Critiques
          </Text>
          <Text variant={"subtitle"} color={"white"}>
            During a group critique session, we asked our peers for feedback
            about which design elements they liked and which could be improved.
            We then took the critiques below and iterate on our previous design.
          </Text>
        </Flex>
        <Flex
          flexWrap={"wrap"}
          gap={".5rem"}
          w="70%"
          justifyContent={"flex-end"}
        >
          {kiwiCritiques.map((c) => (
            <Card borderRadius={"1rem"} w="40%" bg="white">
              <CardBody>
                <Text variant={"tiniestHeader"} mb=".5rem">
                  {c.title}
                </Text>
                <Text variant={"subtitle"}>{c.desc}</Text>
              </CardBody>
            </Card>
          ))}
        </Flex>
      </Flex>
      <Flex
        py="1rem"
        alignItems={"center"}
        justifyContent={"center"}
        flexDir={"column"}
        px={{ base: 10, md: 20 }}
      >
        <Text variant={"subUIHeader"} textAlign={"center"} py="1rem">
          4. Final Prototype
        </Text>
        <iframe
          width="390"
          height="650"
          src="https://www.figma.com/embed?embed_host=share&url=https%3A%2F%2Fwww.figma.com%2Fproto%2F6eo81hU4SOao2cvWsy65UG%2Fanonymous-kiwi-figma%3Fnode-id%3D1%253A172%26starting-point-node-id%3D1%253A172%26scaling%3Dscale-down%26hide-ui%3D1"
        ></iframe>
      </Flex>
    </Flex>
  );
}
